import { CodeBlock, Text } from '@customerio/pluma-components/react';
import { isEmptyString } from '@/utils/string';
import { formatBodyJson, isJsonBody } from '../utils/message-json';

type LiveNotificationMessagePreviewProps = { body: string };

/**
 * Live-notification payload. A JSON payload is pretty-printed with syntax
 * highlighting; anything else renders as plain text. An empty payload shows a
 * hint that content appears once the live notification is sent with a payload.
 */
export function LiveNotificationMessagePreview({ body }: LiveNotificationMessagePreviewProps) {
  if (isEmptyString(body)) {
    return (
      <Text color="subtle" data-test-live-notification-payload-empty>
        No payload to display. It appears here when the live notification is sent with content.
      </Text>
    );
  }

  const isJson = isJsonBody(body);

  return (
    <CodeBlock
      className="fs-mask"
      data-test-live-notification-payload
      code={isJson ? formatBodyJson(body) : body}
      language={isJson ? 'json' : 'text'}
      withLineNumbers
    />
  );
}
